import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import {clone, pick, tap} from 'ramda';
import {View} from 'backbone';

import {queryIn} from '@sinclair-digital/sbg-util/dist/es/element';
import {maybeInt} from '@sinclair-digital/sbg-util/dist/es/number';
import eventChannels from '../../eventChannels';
import TagCollection from '../../collections/common/tagCollection';
// import TagCollection, {systemTagsDimensions} from '../../collections/common/tagCollection';
import {tagComparitor} from '../../models/common/tagModel';
import taggingRightPanelTemplate from '../../templates/stories/taggingRightPanel.hbs';
import tagSearchListTemplate from '../../templates/stories/tagSearchList.hbs';
import {ajaxRequest} from '../../sinclair/sinclair.ajax';
import {messageHandler} from '../../sinclair/sinclair.uiTools';
import {Tags} from '../../components/Tag';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';
import CaliasTagModel from '../../models/common/CaliasTagModel';
import {SOURCE_CALAIS} from '../../constants/tags';


const dimensionValidators = {
    // hash tag must be at least 2 characters, no #, no spaces
    HashTag: name => /^#[^\s#]{2,138}$/.test(name),
};

//:: String -> TagModel -> {}
// const tagViewModel = curry((collectionName, tag) =>
//     Object.assign(
//         {
//             collectionName,
//             cid: tag.cid,
//             draggable: !systemTagsDimensions.has(tag.get('dimension')),
//         },
//         tag.toJSON(),
//     ),
// );

const tagElToTagInfo = el => ({
    name: el.dataset.tagName,
    dimension: el.dataset.tagDimension,
    weight: maybeInt(el.dataset.tagWeight).getOrElse(null),
    removable: el.dataset.tagRemovable === 'true',
});

// noopPromise :: * -> Promise()
const noopPromise = () => Promise.resolve();

export default View.extend({
    template: taggingRightPanelTemplate,
    events: {
        'click #tag-panel-done': 'done',
        'click #tag-panel-cancel': 'cancel',
        'click #add-tag': '_showTagCategories',
        'click .story-tag-result': '_selectTag',
        'click .tag-category': '_selectTagCategory',
        'keyup #tag-input': '_tagInputHandler',
        'click .remove-tag': 'removeTagHandler',
        'click .sda-refresh-auto-tag': 'refreshSuggestedTags',
        'click .sda-CheckboxLarge': '_toggleIncluded',
    },
    el: '#tag-panel',
    tagSearchLimit: 20,
    lastTagSearch: {
        val: null,
        xhr: {},
    },
    _cacheTags() {
        this.startingTags = this.collection.toJSON();
    },
    _loadTagsFromCache() {
        this.collection.reset(this.startingTags);
    },
    _replaceStartingTags(collectionJson) {
        this.startingTags = clone(collectionJson);
        this._loadTagsFromCache();
    },
    _fnRefs: {},
    initialize({fetchSuggestedTags, tags} = {}) {
        Object.assign(this, {
            collection: new TagCollection(tags || []),
            fetchSuggestedTags: fetchSuggestedTags || noopPromise,
            hasSuggestedTags: false,
        });

        //Cached in case user cancels edit
        this._cacheTags();

        this.listenTo(this.collection, 'remove add reset', this.render);
        document.querySelector('body').addEventListener(
            'click',
            this.documentFocusEvent,
            true
        );

        this._fnRefs = {
            open: () => this.onOpen(),
            focusout: (e) => this._focusoutHandler(e),
            focusin: (e) => this._focusInHandler(e),
        };

        this.$el.on('open', this._fnRefs.open);
        this.$el.on('focusout', this._fnRefs.focusout);
        this.$el.on('focusin', this._fnRefs.focusin);
        this.listenTo(this, 'open', this.render);
    },

    documentFocusEvent(event) {
        if (this?.hasFocus === true && this.searching) {
            let current = event.target;
            while (current && (current.tagName !== 'BODY' && current.id !== 'tag-panel')) {
                current = current.parentNode;
            }
            if (current.tagName === 'BODY') {
                // cancel the search
                this.lastTagSearch?.xhr.abort();
            } else {
                this.$el.find('#tag-input').focus();
            }
        }
    },

    /**
     * Override original behavior to remove
     *
     */
    remove() {
        if (this._fnRefs) {
            this.$el.off('open', this._fnRefs.open);
            this.$el.off('focusout', this._fnRefs.focusout);
            this.$el.off('focusin', this._fnRefs.focusin);
        }

        document.querySelector('body').removeEventListener(
            'click',
            this.documentFocusEvent,
            true
        );

        return View.prototype.remove.call(this);
    },

    onOpen() {
        this.trigger('open');
        this.refreshSuggestedTags();
    },
    /**
     * Takes the current tag collection, converts it all to standard objects and returns it sorted
     *  (and without the major story tag)
     *
     * @returns {Object[]}
     * @private
     */
    _getSortedTags() {
        return this.collection.reject(
            tag => tag.get('name') === 'Major Story' && tag.get('dimension') === 'Display'
        )
            .map(tag => tag.toJSON())
            .sort(tagComparitor)
            .map((tag, ind) => {
                tag.order = ind;
                return tag;
            });
    },
    _toggleIncluded({target}) {
        const $tag = $(target).closest('.tag');
        if (target.checked) {
            $tag.removeClass('js-tag-excluded');
        } else {
            $tag.addClass('js-tag-excluded');
        }
        const tagEl = $tag[0];
        const collection = this[tagEl.dataset.collectionName || 'collection'];
        const identifier = pick(['dimension', 'name'], tagElToTagInfo(tagEl));
        const model = collection.findWhere(identifier);
        model.set({included: target.checked});
    },
    /**
     * Only ever a single collection
     *
     * @param {Backbone.Collection} collection
     * @returns {void}
     * @private
     */
    _renderReactComponents(collection) {
        /* eslint-disable react/jsx-no-bind */
        queryIn('.js-sda-Tags', this.el).map(tagContainer => {
            ReactDOM.render(
                <Tags
                    tags={collection.map(tag => tag.toJSON()).sort(tagComparitor)}
                    excludeTag={(tag) => {
                        collection.findWhere({name: tag.name, dimension: tag.dimension})
                            ?.set({included: false});
                        this._renderReactComponents(collection);
                    }}
                    includeTag={(tag) => {
                        collection.findWhere({name: tag.name, dimension: tag.dimension})
                            ?.set({included: true});
                        this._renderReactComponents(collection);
                    }}
                />,
                tagContainer,
            );
            return null;
        });
        /* eslint-enable react/jsx-no-bind */
    },
    render() {
        const tags = this._getSortedTags();

        this.$el.html(
            this.template({
                availableCategories: this.userModel.get('availableCategories'),
                tags,
                hasSuggestedTags: this.hasSuggestedTags,
            }),
        );

        if (this.$('.js-sda-Tags').length) {
            this._renderReactComponents(this.collection);
        }

        return this;
    },
    _focusoutHandler(e) {
        if (e.target.id === 'tag-input') {
            this.timeOutId = setTimeout(() => {
                this.hasFocus = false;
            }, 200);
        }
    },
    _focusInHandler(e) {
        if (e.target.id === 'tag-input') {
            this.timeOutId && clearTimeout(this.timeOutId);
            this.hasFocus = true;
        }
    },
    getTags() {
        return this.collection.toJSON();
    },
    resetTags(tags) {
        this.collection.reset(tags);
    },
    done() {
        const tagCollection = this.collection.toJSON();
        this._cacheTags();
        this.$el.close();
        setTimeout(() => eventChannels.tagging.trigger('done.tagging', tagCollection), 0);
        return this;
    },
    cancel() {
        this._loadTagsFromCache();
        eventChannels.tagging.trigger('cancel.tagging');
        this.$el.close();
        return this;
    },
    _searchForTags() {
        const that = this;
        const val = that
            .$('#tag-input')
            .val()
            .trim()
            .toLowerCase();
        if (val !== that.lastTagSearch.val) {
            that.$('.fa-search').removeClass('fa-search')
                .addClass('fa fa-refresh sda-refresh-auto-tag refresh-in-progress');
            that.isCanceled = false;
            that.searching = true;
            if (that.lastTagSearch.xhr.readyState > 0 && that.lastTagSearch.xhr.readyState < 4) {
                that.isCanceled = true;
                that.lastTagSearch.xhr.abort();
            }
            that._clearTagSearch();
            that.lastTagSearch.val = val;
            const opts = {
                type: 'GET',
                timeout: 30000,
                url: '/api/rest/facade/tag/search',
                tryCount: 0,
                retryLimit: 1,
                data: {
                    term: val,
                    limit: that.tagSearchLimit,
                },
                success(_data) {
                    let data = Array.isArray(_data.data) ? _data.data : _data;
                    that.searching = false;
                    that.$('.refresh-in-progress').removeClass('fa fa-refresh sda-refresh-auto-tag refresh-in-progress')
                        .addClass('fa-search');
                    if (data.length === 0) {
                        that.$('#story-tag-categories').addClass('sda-dropdown-open');
                    } else {
                        if (getFeatureFlag('majorStoryToggle')) {
                            data = data.filter(tag => !(tag.dimension === 'Display' && tag.name === 'Major Story'));
                        }
                        console.log(getFeatureFlag('storyline:hide_ai_generated_search_results'));
                        if (getFeatureFlag('storyline:hide_ai_generated_search_results')) {
                            data = data.filter(tag => tag.dimension !== 'AI Generated');
                        }
                        that.$('#story-tags-dropdown').html(tagSearchListTemplate(data));
                    }
                },
                error(event, xhrTextStatus) {
                    if (xhrTextStatus === 'timeout') {
                        this.tryCount += 1;
                        if (this.tryCount <= this.retryLimit) {
                            $.ajax(this);
                            return;
                        } else {
                            that.$('#story-tag-categories').addClass('sda-dropdown-open');
                        }
                    }
                    if (!that.isCanceled) {
                        that.searching = false;
                        that.$('.refresh-in-progress').removeClass('fa fa-refresh sda-refresh-auto-tag refresh-in-progress')
                            .addClass('fa-search');
                        that.$('#story-tags-dropdown').html(tagSearchListTemplate([]));
                    } else {
                        that.isCanceled = false;
                    }
                },
            };
            that.lastTagSearch.xhr = ajaxRequest(opts);
        }
    },
    _clearTagSearch() {
        this.lastTagSearch.val = '';
        this.$('#story-tags-dropdown').html('');
        this.$('#story-tag-categories').removeClass('sda-dropdown-open');
        this.$('#story-tags-dropdown').addClass('sda-dropdown-open');
    },
    _traverseTagDropdowns(direction) {
        const that = this;
        const focusClass = 'focused-tagging-option';
        const $li = that.$('.sda-dropdown-open>li:visible');
        const $currentFocus = that.$('.' + focusClass);

        if (direction === 'up') {
            if ($currentFocus.length) {
                if ($currentFocus.prev(':visible')) {
                    $currentFocus
                        .removeClass(focusClass)
                        .prev(':visible')
                        .addClass(focusClass);
                } else {
                    $currentFocus.removeClass(focusClass);
                    $li.last().addClass(focusClass);
                }
            } else {
                $li.last().addClass(focusClass);
            }
        } else if (direction === 'down') {
            if ($currentFocus.length) {
                if ($currentFocus.next(':visible')) {
                    $currentFocus
                        .removeClass(focusClass)
                        .next(':visible')
                        .addClass(focusClass);
                } else {
                    $currentFocus.removeClass(focusClass);
                    $li.first().addClass(focusClass);
                }
            } else {
                $li.first().addClass(focusClass);
            }
        }
    },
    _tagInputHandler(e) {
        const val = this.$('#tag-input').val();
        const $currentDropdown = $(e.target)
            .parent()
            .find('.sda-dropdown-open');

        if (val.length) {
            this._searchForTags();
        }

        if (val.length === 0) {
            this._clearTagSearch();
            $('.refresh-in-progress').removeClass('fa fa-refresh sda-refresh-auto-tag refresh-in-progress')
                .addClass('fa-search');
        }

        switch (e.which) {
            case 13: // Enter = add new tag (if no results) or searches
                if (this.$('.story-tag-result:visible').length !== 0) {
                    const focusClass = '.focused-tagging-option';
                    const $focus = this.$(focusClass);
                    if ($focus.length) {
                        $focus
                            .find('a')
                            .trigger('click')
                            .removeClass(focusClass);
                    } else {
                        this._searchForTags();
                    }
                }

                break;

            case 27: // escape
                this.lastTagSearch.xhr.abort();
                break;

            case 38: // up arrow
                e.preventDefault();
                if ($currentDropdown.attr('id') === 'story-tags-dropdown') {
                    this._traverseTagDropdowns('up');
                }

                break;

            case 40: //down arrow
                e.preventDefault();
                if ($currentDropdown.attr('id') === 'story-tags-dropdown') {
                    this._traverseTagDropdowns('down');
                }

                break;
        }
    },
    _showTagCategories() {
        if (this.$('#tag-input').val()) {
            this.$('#story-tags-dropdown').removeClass('sda-dropdown-open');
            this.$('#story-tag-categories').addClass('sda-dropdown-open');
            this.$('#tag-input').focus();
        } else {
            messageHandler('error', 'Please enter a tag name first');
        }
    },
    _selectTagCategory(e) {
        const cleanUpAndTruncate = (input, len) =>
            input
                .trim()
                .replace(/\s+/g, ' ')
                .substr(0, len);

        const $input = this.$('#tag-input');
        const name = cleanUpAndTruncate($input.val(), 40);

        if (name !== '') {
            const dimension = $(e.target).data('category');
            const invalid = dimensionValidators[dimension] && !dimensionValidators[dimension](name);
            $input.sdaToggleError(`Not a valid ${dimension}`, invalid);
            this._hideDropdown();
            this.$('#story-tag-categories').removeClass('sda-dropdown-open');
            this.$('#story-tags-dropdown')
                .html('')
                .addClass('sda-dropdown-open');
            if (!invalid) {
                $input.val('').focus();
                this.addTag({
                    name,
                    dimension,
                    weight: 1,
                    removable: true,
                    userGenerated: true,
                });
            }
        }
    },
    _hideDropdown() {
        this.$('#story-tag-results').html('');
    },
    _selectTag(e) {
        const that = this;
        const tag = $(e.target)
            .closest('.story-tag-result')
            .data();
        that.addTag(Object.assign({userGenerated: true, weight: 1, included: true}, tag));
        that._hideDropdown();
        that.$('#tag-input').val('');
        $('#story-tags-dropdown').html('');
        that.lastTagSearch.val = null;
    },
    addTag(tag) {
        if (!this.collection) {
            this.collection = new TagCollection();
        }
        this.collection.merge([tag]);
        this._renderReactComponents(this.collection);
        return this;
    },
    addTags(tags) {
        if (!this.collection) {
            this.collection = new TagCollection();
        }
        if ($.isArray(tags)) {
            this.collection.merge(tags);
        }
        return this;
    },
    removeTag(tag) {
        this.collection.remove(tag);
        return this;
    },
    removeTags(tags) {
        if ($.isArray(tags)) {
            this.collection.remove(tags);
        }
        return this;
    },
    removeTagHandler({target}) {
        const tagEl = $(target).closest('.tag')[0];
        const collection = this[tagEl.dataset.collectionName || 'collection'];
        const identifier = pick(['dimension', 'name'], tagElToTagInfo(tagEl));
        const model = collection.findWhere(identifier);
        collection.remove(model);
    },
    refreshSuggestedTags() {
        const $preloader = this.$('.sda-refresh-auto-tag');
        $preloader.addClass('refresh-in-progress');
        this._handlerChanged = false;

        return this.fetchSuggestedTags()
            .then(
                tap(response => {
                    $preloader.removeClass('refresh-in-progress');
                    if (response) {
                        this.hasSuggestedTags = true;

                        // we want to re-add suggested tags and remove any that are no longer included
                        const allNonSuggested = this.collection.reject(tag => tag instanceof CaliasTagModel);

                        // we want to remove any items that are not included in the new set, but we want to
                        // merge an existing (to maintain ordering) and add any new items
                        this.collection.set(
                            [
                                ...allNonSuggested,
                                ...(
                                    response.map(
                                        ({order: __order, ...rest}) => ({
                                            ...rest,
                                            source: SOURCE_CALAIS,
                                        }))
                                ),
                            ],
                            {remove: true, merge: true, add: true, sort: true, silent: true}
                        );
                        this.render();
                    }
                }),
            )
            .catch(() => {
                messageHandler(
                    'error',
                    'There was an error loading package content.  Some data may be missing.',
                    'Please try to reload the story.',
                );
            });
    },
    setRefreshButtonHandler(handler) {
        this.fetchSuggestedTags = handler;
        this._handlerChanged = true;
    },
});
